import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import { Divider, Grid, Tooltip } from '@mui/material';
import { convertToReadable } from '../../../helpers';
import StudentAvatar from '../../geebee/icons/course-details-page/StudentAvatar';
var SimilarStudentCard = function (_a) {
    var _b, _c;
    var studentData = _a.studentData;
    var studentInfo = [
        {
            label: 'Highest Qualification',
            value: studentData === null || studentData === void 0 ? void 0 : studentData.highestQualification
        },
        {
            label: 'Specialisation',
            value: (_b = studentData === null || studentData === void 0 ? void 0 : studentData.specializationOfHighestQualification) !== null && _b !== void 0 ? _b : '-'
        },
        {
            label: 'Intake',
            value: (studentData === null || studentData === void 0 ? void 0 : studentData.intake) ? convertToReadable(studentData === null || studentData === void 0 ? void 0 : studentData.intake) : '-'
        },
        {
            label: "".concat(studentData === null || studentData === void 0 ? void 0 : studentData.highestQualification, " Score (out of 100)"),
            value: (_c = studentData === null || studentData === void 0 ? void 0 : studentData.gradesInHighestQualificationOutOf100) !== null && _c !== void 0 ? _c : '-'
        },
        (studentData === null || studentData === void 0 ? void 0 : studentData.englishExamGiven) && {
            label: "".concat(studentData === null || studentData === void 0 ? void 0 : studentData.englishExamType, " Score"),
            value: studentData === null || studentData === void 0 ? void 0 : studentData.englishExamScore
        },
        (studentData === null || studentData === void 0 ? void 0 : studentData.englishExamGiven) === false && {
            label: 'English Exam',
            value: 'Not Given'
        }
    ];
    return (React.createElement("div", { className: "lfc-p-3 lfc-bg-gbTokens-grey-A200 lfc-rounded-lg lfc-h-full" },
        React.createElement("div", { className: "lfc-flex lfc-gap-x-2 lfc-items-center" },
            React.createElement("div", { className: "lfc-flex lfc-items-center lfc-h-full" },
                React.createElement(StudentAvatar, null)),
            React.createElement("div", { className: "lfc-w-full" },
                React.createElement(GBTypography, { variant: "sh3", className: "lfc-text-primary-700" }, studentData === null || studentData === void 0 ? void 0 : studentData.firstName),
                React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-gbTokens-grey-A900 lfc-flex" },
                    React.createElement("span", { className: "lfc-mr-1 lfc-flex lfc-mt-0.5" },
                        React.createElement("i", { className: "fi fi-rs-marker" })), studentData === null || studentData === void 0 ? void 0 :
                    studentData.city,
                    ", ", studentData === null || studentData === void 0 ? void 0 :
                    studentData.state),
                React.createElement(GBTypography, { variant: "caption1", className: "lfc-text-gbTokens-grey-A900 lfc-flex" },
                    React.createElement("span", { className: "lfc-mr-1 lfc-flex lfc-mt-0.5" },
                        React.createElement("i", { className: "fi fi-rr-book" })), studentData === null || studentData === void 0 ? void 0 :
                    studentData.courseName))),
        React.createElement(Divider, { className: "lfc-text-grey-200 lfc-my-2" }),
        React.createElement(Grid, { container: true, rowSpacing: 4, columnSpacing: 2 }, studentInfo === null || studentInfo === void 0 ? void 0 : studentInfo.map(function (info, index) {
            if (!info)
                return null;
            return (React.createElement(Grid, { item: true, key: index, xs: 6, xl: 4 },
                React.createElement(GBTypography, { variant: "caption2", className: "lfc-text-grey-700 lfc-block" }, info === null || info === void 0 ? void 0 : info.label),
                React.createElement(Tooltip, { title: info === null || info === void 0 ? void 0 : info.value, arrow: true },
                    React.createElement(GBTypography, { variant: "caption1Bold", className: "lfc-text-grey-900 lfc-line-clamp-1 hover:lfc-line-clamp-none" }, info === null || info === void 0 ? void 0 : info.value))));
        }))));
};
export default SimilarStudentCard;
//# sourceMappingURL=SimilarStudentCard.js.map